import { render, staticRenderFns } from "./PreviewProductModal.vue?vue&type=template&id=32b29f3b&scoped=true&lang=pug"
import script from "./PreviewProductModal.vue?vue&type=script&lang=js"
export * from "./PreviewProductModal.vue?vue&type=script&lang=js"
import style0 from "./PreviewProductModal.vue?vue&type=style&index=0&id=32b29f3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b29f3b",
  null
  
)

export default component.exports